import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import authService from '../../services/authService';

export const fetchUser = createAsyncThunk(
  'auth/fetchUser',
  async (userId, { rejectWithValue }) => {
    try {
      const response = await authService.getUserProfile(userId);
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const logout = createAsyncThunk(
  'auth/logout',
  async (_, { rejectWithValue }) => {
    try {
      await authService.logout();
      sessionStorage.removeItem('user');
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const authSlice = createSlice({
  name: 'auth',
  initialState: {
    user: JSON.parse(sessionStorage.getItem('user')) || null,
 loading: false,
 error: null,
  },
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload;
      if (action.payload) {
        sessionStorage.setItem('user', JSON.stringify(action.payload));
      } else {
        sessionStorage.removeItem('user');
      }
    },
  },
  extraReducers: (builder) => {
    builder

    .addCase(fetchUser.fulfilled, (state, action) => {
      const userData = {
        ...action.payload,
        id: action.payload._id || action.payload._id,
      };
      
      state.user = userData;
      sessionStorage.setItem('user', JSON.stringify(userData));

    })
    
      .addCase(fetchUser.rejected, (state, action) => {
        state.error = action.payload;
      })

      
  },
});

export const { setUser } = authSlice.actions;

export default authSlice.reducer;
